import { render, staticRenderFns } from "./StockDetail.vue?vue&type=template&id=2ece1f9e"
import script from "./StockDetail.vue?vue&type=script&lang=js"
export * from "./StockDetail.vue?vue&type=script&lang=js"
import style0 from "./StockDetail.vue?vue&type=style&index=0&id=2ece1f9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports